import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import swal from 'sweetalert2';
import { HistoricoFinSimulacaoComponent } from '../../../modals/historico-fin-simulacao/historico-fin-simulacao.component';
import { MargemLucroComponent } from '../../../../margem-lucro/margem-lucro.component';
import { Cliente } from '../../../../models/cliente';
import { CondicaoDePagamento } from '../../../../models/condicao-de-pagamento';
import { DadosCalculo } from '../../../../models/dados-calculo';
import { FinSimulacaoStatus, TipoCalculoPedido, TipoAplicacao, FinSimulacaoOrigem, TipoArquivo } from '../../../../models/enum';
import { FinSimulacao } from '../../../../models/fin-simulacao';
import { FinSimulacaoStatusLog } from '../../../../models/fin-simulacao-status-log';
import { Frete } from '../../../../models/frete';
import { Pedido, ItemPedido } from '../../../../models/pedido';
import { PremissasOrcPed } from '../../../../models/premissas-orc-ped';
import { ResumoPedido } from '../../../../models/resumoPedido';
import { Seguro } from '../../../../models/seguro';
import { UsuarioLogado } from '../../../../models/usuario-logado';
import { VendaEntrega } from '../../../../models/venda-entrega';
import { VendaSeguro } from '../../../../models/venda-seguro';
import { CarregandoService } from '../../../../services/carregando.service';
import { ClienteService } from '../../../../services/cliente.service';
import { CondicaoDePagamentoService } from '../../../../services/condicao-de-pagamento.service';
import { FinSimulacaoService } from '../../../../services/fin-simulacao.service';
import { FreteService } from '../../../../services/frete.service';
import { GlobalService } from '../../../../services/global.service';
import { NotificacaoService } from '../../../../services/notificacao.service';
import { PedidoService } from '../../../../services/pedido.service';
import { PremissasService } from '../../../../services/premissas.service';
import { SeguroService } from '../../../../services/seguro.service';
import { FinSimulacaoStatusLogUnificado } from '../../../../models/fin-simulacao-status-log-unificado';
import { FilaTarefa } from '../../../../models/filas/fila-tarefa';
import { FinPropostasComponent } from '../../../components/fin-propostas/fin-propostas.component';
import { FinanciamentoService } from '../../../../services/financiamento.services';
import { IntegradorFinanciadoraSimples } from '../../../../models/financiamento/integrador-financiadora-simples';
import { ArquivoService } from '../../../../services/arquivo.service';
import { UtilitarioService } from '../../../../services/utilitario.service';
import { GiFinSimulacaoModel } from "../../../../dominio/gi-fin-simulacao-model";
import { AnaliseCreditoIntegradorService } from "../../../../core/services/analise-credito-integrador.service";
import { AnaliseCreditoIntegradorModel } from "../../../../dominio/analise-credito-integrador-model";
import { QueryFilterService } from "../../../../core/services/query-filter-service";
import { PaginatedModel } from "../../../../dominio/paginated-model";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { PaginatorServiceV2 } from "../../../../core/services/paginator-service-v2";
import { SelectBoxV2Model } from "../../../../dominio/ui/select-box-v2-model";

// jquery
declare const $: any;

@Component({
  selector: 'app-fin-simulacao',
  templateUrl: './fin-simulacao.component.html',
  styleUrls: ['./fin-simulacao.component.scss']
})
export class FinSimulacaoComponent implements OnInit, OnChanges {

  @Input() finSimulacao: GiFinSimulacaoModel;
  @Input() tarefa: FilaTarefa;
  // Sem permissão de edição na tarefa (ex.: Auxiliar): oculta todas as ações.
  @Input() somenteLeitura = false;

  logs: FinSimulacaoStatusLogUnificado[] = [];
  tabIndex = 0;
  premissas: PremissasOrcPed = new PremissasOrcPed();
  usuarioLogado: UsuarioLogado;
  integrador: Cliente = new Cliente();

  alterou = true;

  FinSimulacaoStatus = FinSimulacaoStatus;

  FinSimulacaoOrigem = FinSimulacaoOrigem;

  financiadoras: IntegradorFinanciadoraSimples[] = [];

  panelOpenState = false;
  analisesIntegrador: AnaliseCreditoIntegradorModel[] = [];
  tipoSituacaoAnalise: SelectBoxV2Model<number>[] = [
    { id: 1, label: "Apto" },
    { id: 2, label: "Não Apto" },
    { id: 3, label: "Bloqueado" },
  ];
  paginador: PaginatedModel;

  @ViewChild('historicoFinSimulacaoComp', { static: false }) historicoFinSimulacaoComp: HistoricoFinSimulacaoComponent;
  @ViewChild('finPropostasComp', { static: false }) finPropostasComp: FinPropostasComponent;
  @ViewChild("paginator", { static: false }) paginator: MatPaginator;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private finSimulacaoService: FinSimulacaoService,
    private clienteService: ClienteService,
    private globalService: GlobalService,
    public dialog: MatDialog,
    private financiamentoService: FinanciamentoService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private analiseCreditoIntegradorService: AnaliseCreditoIntegradorService,
    private queryFilterService: QueryFilterService,
    private paginatorServiceV2: PaginatorServiceV2,
  ) { }

  async ngOnInit() {
    this.paginador = this.paginatorServiceV2.createInstance();
    this.usuarioLogado = await this.globalService.consultaUsuario();

    const savedTab = localStorage.getItem('fin_simulacao_active_tab');
    if (savedTab !== null) {
      this.tabIndex = Number(savedTab);
      localStorage.removeItem('fin_simulacao_active_tab');
    }

    this.buscarDadosSimulacao();
    await this.buscarAnalisesIntegrador();
  }

  async ngOnChanges(changes: SimpleChanges) {

    if (changes.finSimulacao && changes.finSimulacao.currentValue !== changes.finSimulacao.previousValue) {
      await this.atualizar();
    }
  }

  async atualizar() {
    this.buscarDadosSimulacao();

    if (this.finPropostasComp !== null && this.finPropostasComp !== undefined) {
      await this.finPropostasComp.ngOnInit();
    }
  }

  buscarDadosSimulacao() {
    if (this.finSimulacao) {
      this.buscarLogs();
      this.buscarIntegrador();
      this.buscarFinanciadoras();
    }
  }

  buscarLogs() {
    this.carregandoService.mostra('buscarLogs');
    this.finSimulacaoService.consultarLogPorIdSimulacao(this.finSimulacao.id).subscribe(dados => {
      this.logs = dados;
      this.carregandoService.esconde('buscarLogs');
    }, (erro) => {
      this.carregandoService.esconde('buscarLogs');
      this.notificacaoService.erro(erro);
    });

    if (this.historicoFinSimulacaoComp !== null && this.historicoFinSimulacaoComp !== undefined) {
      this.historicoFinSimulacaoComp.buscarSimulacoesDoPedido();
    }
  }

  buscarIntegrador() {
    this.carregandoService.mostra('buscarIntegrador');
    this.clienteService.consultarPorIdCliente(this.finSimulacao.integrador.id, true).subscribe(dados => {
      this.integrador = dados;
      this.carregandoService.esconde('buscarIntegrador');
    }, (erro) => {
      this.carregandoService.esconde('buscarIntegrador');
      this.notificacaoService.erro(erro);
    });
  }

  buscarFinanciadoras() {
    this.carregandoService.mostra('buscarFinanciadoras');
    this.financiamentoService.consultarFinanciadorasParaIntegrador(this.finSimulacao.integrador.id, true).subscribe(dados => {
      this.financiadoras = dados;

      this.financiadoras.forEach(p => {
        this.buscarImagem(p);
      });

      this.carregandoService.esconde('buscarFinanciadoras');
    }, (erro) => {
      this.carregandoService.esconde('buscarFinanciadoras');
      this.notificacaoService.erro(erro);
    });
  }

  buscarImagem(financiadora: IntegradorFinanciadoraSimples) {
    try {
      financiadora.imagem$ = this.arquivoService.baixarArquivo(financiadora.idFinanciadora, TipoArquivo.FinanciadoraImagem)
        .map(m => this.utilitarioService.toBase64ComInicio(m)).toPromise();
      financiadora.imagem$.then(p => { financiadora.buscouImagem = true; }).catch(p => { financiadora.semImagem = true; });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  changeTabIndex(index) {

    this.tabIndex = index;

    if (index === 1) {
      // this.selecionarAnexo();
    }
  }

  buscarAnalisesIntegrador() {
    this.carregandoService.mostra("buscarAnalisesIntegrador");

    const queryFilter = this.queryFilterService
      .getQueryBuilder()
      .setPage(this.paginador.page)
      .setPageSize(this.paginador.pageSize)
      .addOrderBy("criadoEm", true)
      .build();

    this.analiseCreditoIntegradorService.listar(this.finSimulacao.integrador.id, queryFilter).subscribe(
      (data) => {
        this.analisesIntegrador = data.results;
        this.paginador = this.paginatorServiceV2.createInstance(data.pagination);
        this.carregandoService.esconde("buscarAnalisesIntegrador");
      },
      (erro) => {
        this.carregandoService.esconde("buscarAnalisesIntegrador");
        this.notificacaoService.erro(erro);
      }
    );
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.paginador.page = pageEvent.pageIndex + 1;
    this.paginador.pageSize = this.paginatorServiceV2.setPageSize(pageEvent.pageSize);

    this.buscarAnalisesIntegrador();
  }

  retornaSituacaoAnalise(idSituacao: number): string {
    const situacao = this.tipoSituacaoAnalise.find((x) => x.id === idSituacao);

    if (situacao == null) {
      return "indefinido";
    }

    return situacao.label;
  }

  retornaExpiracao(analise: AnaliseCreditoIntegradorModel): string {
    if (analise.dataExpiracao == null) {
      return 'Validade Indefinida';
    }

    const d = new Date(analise.dataExpiracao);
    return d.toLocaleDateString('pt-BR');
  }
}
